import React from 'react';
import Fact from '../Fact';
import TeaserCard from '../TeaserCard';
import TeaserTools from '../TeaserTools';
import TeaserStorys from '../TeaserStorys';
import TeaserCardNews from '../TeaserCard/TeaserCardNews';
import TeaserCardFullImage from '../TeaserCard/TeaserCardFullImage';
import TeaserAusAltMachNeu from '../TeaserAusAltMachNeu/TeaserAusAltMachNeu';
import Publication from '../Publication';
import Event from '../Event';

const CardGridItem = ({ name, data }: { name: string; data: any }) => {
  const componentsMap: { [propertyName: string]: React.FC<any> } = {
    TeaserCard,
    TeaserTools,
    TeaserStorys,
    TeaserCardNews,
    TeaserCardFullImage,
    Publication,
    Publications: Publication,
    TeaserAusAltMachNeu,
    Fact,
    Event,
  };

  const TagName = componentsMap[name];

  return TagName ? <TagName data={data} /> : null;
};

export default CardGridItem;
